// «الأقساط» inside the accounts module (HANDOFF §3: /accounts/installments ·
// boards accounts/installments--plan, --new). Flag erp.installments (the
// accounts module itself needs erp.accounts), manager+ (HANDOFF §9 — staff
// never see balances; the server enforces). Off ⇒ absent from menu and
// routes; a deep link lands on «اليوم» with the reason.

import type { RouteObject } from 'react-router-dom';
import { gate, type MenuItem } from '@/app/module-types';

export const INSTALLMENTS_FLAG = 'erp.installments';
const g = gate({ flag: INSTALLMENTS_FLAG, minRole: 'manager' });

export const installmentsRoutes: RouteObject[] = [
  { path: '/accounts/installments', lazy: () => import('./screens/InstallmentsList').then((m) => ({ Component: m.InstallmentsListRoute })), handle: g },
  { path: '/accounts/installments/new', lazy: () => import('./screens/InstallmentsList').then((m) => ({ Component: m.NewPlanRoute })), handle: g },
  { path: '/accounts/installments/:planId', lazy: () => import('./screens/InstallmentPlan').then((m) => ({ Component: m.InstallmentPlanRoute })), handle: g },
];

/** Links other accounts items use: the invoices screen opens «خطة أقساط جديدة» with `newPlanPath(invoiceId)`. */
export { newPlanPath, planPath } from './lib/links';// The invoice panel's «خطة أقساط» line action lives in ./components/NewPlanAction
// and is imported by path (like vouchers' VoucherView), so this barrel — loaded
// eagerly by the module registry — stays free of screen code.

export const installmentsMenu: MenuItem[] = [{ key: 'installments', label: 'الأقساط', to: '/accounts/installments', flag: INSTALLMENTS_FLAG, minRole: 'manager' }];
